import React from 'react';
import {
  Link,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Grid,
  Typography,
  Divider,
} from '@material-ui/core';

import classes from '../../css/getCSS';
import * as routes from '../../config/routes';
import * as constants from '../../config/constants';


const footer = () => {
  const isAnjalAvsar = window.location.host.includes('anjalavsar.com');

  const date = new Date().getFullYear();

  const sites = constants.SITES.map((val) => {
    return (
      <React.Fragment key={val[0]}>
        <a className={classes.linkDeCSS} href={`//${val[0]}`}>{val[1]}</a><br/>
      </React.Fragment>
    );
  });

  return isAnjalAvsar ? (
    <div className={classes.footerWrapper}>
      <div className={classes.container}>
        <Grid container spacing={16}>
          <Grid item md={12} sm={12} xs={12}>
            <Typography variant="subheading"><b>Disclaimer</b></Typography>
            <br />
            <Typography variant="body1">
              We at Lohana Mahaparishad Matrimony Committee members and our team do not accept any responsibility for the correctness of the profile data put in by each and every candidates themselves in our website.
            </Typography>
          </Grid>
        </Grid>
        <br />
        <Divider />
        <br />
        <Grid container spacing={16}>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>General</b></Typography>
            <br />
            <Typography variant="subheading">
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'about' })}>
                About
              </Link> <br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'services' })}>
                Services
              </Link><br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'team' })}>
                Team
              </Link><br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'contact' })}>
                Contact Us
              </Link>
            </Typography>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>Other Anjal ane Avsar Websites</b></Typography> <br />
            {sites}
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>Contact Us</b></Typography>
            <br />
            <Typography variant="subheading">
              +91 9869009363 | +91 22 26630152 <br />
              jayendrarsodha@rediffmail.com <br />
              Contact Timings: <br /> Monday to Friday, 11:00 to 1:00 PM
            </Typography>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>Support</b></Typography>
            <br />
            <Typography variant="subheading">
              Tech Support only by email
              <br />
              lagnasetu@lohanamahaparishad.org
            </Typography>
          </Grid>
        </Grid>
        <br /><br />
        <Divider />
        <div align="center" className={classes.padding10}>
          <Typography variant="body1">
            Copyright&nbsp; <i className="far fa-copyright" />&nbsp; {date} &nbsp;Lohana Mahaparishad <br />
          </Typography>
        </div>
      </div>
    </div>
  ) : (
    <div className={classes.footerWrapper}>
      <div className={classes.container}>
      <Grid container spacing={16}>
          <Grid item md={12} sm={12} xs={12}>
            <Typography variant="subheading"><b>Disclaimer</b></Typography>
            <br />
            <Typography variant="body1">
              We at Lohana Mahaparishad Matrimony Committee members and our team do not accept any responsibility for the correctness of the profile data put in by each and every candidates themselves in our website.
            </Typography>
          </Grid>
        </Grid>
        <br />
        <Divider />
        <br />
        <Grid container spacing={16}>
          <Grid item md={2} sm={12} xs={12}>
            <Typography variant="subheading"><b>General</b></Typography>
            <br />
            <Typography variant="subheading">
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'about' })}>
                About
              </Link> <br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'services' })}>
                Services
              </Link><br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'team' })}>
                Team
              </Link><br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'contact' })}>
                Contact Us
              </Link><br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.TERMS_AND_CONDITION, { page: 'termsAndConditions' })}>
                Terms & Conditions
              </Link><br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.TERMS_AND_CONDITION, { page: 'privacyPolicy' })}>
                Disclaimer & PrivacyPolicy
              </Link>
            </Typography>
          </Grid>
          <Grid item md={6} sm={12} xs={12}>
            <Typography variant="subheading"><b>Our Zonal Websites</b></Typography> <br />
            <Typography variant="subheading">
            <Grid container spacing={16}>
                <Grid item md={6} sm={6} xs={12} className={classes.rmSpaceLink}>
                  {
                    sites.map((data,index)=>
                      index<Math.ceil(sites.length/2) && data
                    )
                  }
                </Grid>
                <Grid item md={6} sm={6} xs={12} className={classes.rmSpaceLink}  >
                  {
                    sites.map((data,index)=>
                      index>=Math.ceil(sites.length/2) && data
                    )
                  }
                </Grid>
            </Grid>
            </Typography> <br />

          </Grid>
          <Grid item md={4} sm={12} xs={12}>
            <Typography variant="subheading"><b>Contact Us</b></Typography>
            <br />
            <Typography variant="body1">
              SHREE LOHANA MAHAPARISHAD,<br/>
              Shree lohana kanya shala, netaji subhash chandra bose road,<br/>
              near mulund police station, mulund (west),<br/>
              Mumbai – 400080<br/>
              Maharashtra – INDIA<br/>
              {/*Phone : <a className={classes.linkDeCSS} href="tel:+912225617350">+91 22 25617350</a><br/>*/}
              (From Monday To Friday Time 11am To 1pm  only )<br/>
              Mr Jayendra Sodha    Mobile :  <a className={classes.linkDeCSS} href="tel:+919869009363">+91 98690 09363</a><br/>
              Mr Vinod Bhimjyani   Mobile :  <a className={classes.linkDeCSS} href="tel:+919833325907">+91 98333 25907</a>

            </Typography>
            <Typography variant="body1">
              Email Id : <a className={classes.linkDeCSS} href="mailto:lagnasetu@lohanamahaparishad.org">lagnasetu@lohanamahaparishad.org</a>
            </Typography>
            <Typography variant="body1">
              Bureau Contact Time:
            </Typography>
            <Typography variant="body1">
              Saturday  from 3.00 pm to  6.00pm
            </Typography>
            <br/>
            <Typography variant="subheading"><b>Support</b></Typography>
            <br />
            <Typography variant="subheading">
              Tech Support only by email
              <br />
              <a className={classes.linkDeCSS} href="mailto:lagnasetu@lohanamahaparishad.org">lagnasetu@lohanamahaparishad.org</a>
            </Typography>
          </Grid>
          {/*<Grid item md={3} sm={6} xs={12}>*/}
          {/*  */}
          {/*</Grid>*/}
        </Grid>
        <br /><br />
        <Divider />
        <div align="center" className={classes.padding10}>
          <Typography variant="body1">
            Copyright&nbsp; <i className="far fa-copyright" />&nbsp; {date} &nbsp;Lohana Mahaparishad<br />
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default footer;



// WEBPACK FOOTER //
// ./src/common/components/Footer.js